/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useAppSelector } from "../../../app/hooks";
import { selectUserAuthContext } from "../../../features/console/consoleSlice";
import { getValidatedUserPayload } from "../../..";

interface GallusAgilityRedirectProps {}

export const GallusAgilityRedirect = (props: GallusAgilityRedirectProps) => {
  const userAuthContext = useAppSelector(selectUserAuthContext);

  /* useEffect(() => {
    async function fetchPayload() {
      try {
        const validatedUserPayload = await getValidatedUserPayload();
        if (userAuthContext) {
          LazyGA_User_CheckinQuery({ userPayload: validatedUserPayload });
        }
      } catch (e) {
        console.error(e);
      }
    }
    fetchPayload();
  }, []); */

/*   useEffect(() => {
    if (
      LazyGA_User_CheckinQueryResult.isSuccess &&
      LazyGA_User_CheckinQueryResult.status === "fulfilled"
    ) {
      window.location.href = "https://www.gallusinsights.co/pcredirect";
    }
  }, [LazyGA_User_CheckinQueryResult]); */

  return (
    <div>
      Error
    </div>
  );
};
